var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseDownBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "down",
    d: "M11.2,15.287a.617.617,0,0,1-.9,0L3.94,8.633a.687.687,0,0,1,.016-.924.617.617,0,0,1,.884-.016l5.914,6.183,5.914-6.183A.619.619,0,0,1,17.29,7.5a.651.651,0,0,1,.459.48.685.685,0,0,1-.183.651L11.2,15.287Z",
    transform: "translate(-3.769 -7.481)",
    fill: "#999",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseDownBtn);
export default __webpack_public_path__ + "static/media/collapse-down-btn.1c6bd90b1c9bb21d3d6e6df03d9e08d6.svg";
export { ForwardRef as ReactComponent };